'use client'

import { mdiLoading } from '@mdi/js'
import Icon from '@mdi/react'
import { cn } from '@/utils/ui.js'

export const LoadingIndicator = ({ children = null, className, size = 4, ...props }) =>
  children ? (
    <div
      className={cn('flex grow flex-col items-center justify-center gap-6', className)}
      {...props}>
      <Icon className="animate-spin" path={mdiLoading} size={size} />
      <div className="flex flex-col justify-center text-center">{children}</div>
    </div>
  ) : (
    <Icon className={cn('animate-spin', className)} path={mdiLoading} size={size} {...props} />
  )

export const LoadingIndicatorTitle = ({ children, className, ...props }) => (
  <div className={cn('text-2xl', className)} {...props}>
    {children}
  </div>
)

export const LoadingIndicatorSubTitle = ({ children, className, ...props }) => (
  <div className={cn('text-lg', className)} {...props}>
    {children}
  </div>
)

export const RouteLoadingIndicator = ({ ...props }) => (
  <LoadingIndicator {...props}>Loading...</LoadingIndicator>
)
